import { FilterUtil } from '../../base/shared/filter-util';
import { Injectable } from '@angular/core';
import { ShowInactiveService } from '../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../base/shared/syncfusion/adaptor-service.interface';
import { Observable } from 'rxjs';
import { IPagedItems } from '../../base/shared/syncfusion/paged-items.interface';
import {
  FilterCondition,
  FilterDTO,
  PagedResultDTOOfSavedReportDTO,
  SavedReportClient,
  SavedReportFileDTO,
  SortDirection,
} from '../../base/models/models.swagger.generated';
import { DropDownItem } from '../../base/shared/drop-down-item.model';
import { ClientService } from '../../base/services/client/client.service';
import { tap } from 'rxjs/operators';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends ShowInactiveService implements IAdaptorService {

  public reportFilter = null;

  public companyDropdownValues: DropDownItem[] = [];
  public tariffDropdownValues: DropDownItem[] = [];
  public subscriptionDropdownValues: DropDownItem[] = [];
  public zoneDropdownValues: DropDownItem[] = [];
  public parkerDropdownValues: DropDownItem[] = [];

  constructor(private savedReportClient: SavedReportClient,
    private clientService: ClientService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    let selectedClientId = this.clientService.selectedClient?.id;
    if (!selectedClientId) {
      selectedClientId = 0;
    }
    FilterUtil.correctDateTimeFilters(filters, 'CreatedDateTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    this.correctCreatedByFilters(filters);
    return this.savedReportClient.searchSavedReports(selectedClientId, filters, skip, take, '', SortDirection.Ascending, true).pipe(
      tap((pagedItems: PagedResultDTOOfSavedReportDTO) => {
        if (pagedItems.items) {
          pagedItems.items.forEach(item => {
            (item as any).createdByName = item.createdBy.firstname + ' ' + item.createdBy.lastname;
          });
        }
      })
    );
  }

  public getUserReports(): Observable<IPagedItems> {
    return this.savedReportClient.searchSavedReports(0, null, 0, 0, '', SortDirection.Ascending, true).pipe(
      tap((pagedItems: PagedResultDTOOfSavedReportDTO) => {
        if (pagedItems.items) {
          pagedItems.items.forEach(item => {
            (item as any).createdByName = item.createdBy.firstname + ' ' + item.createdBy.lastname;
          });
        }
      })
    );
  }

  public addRecord(data: any): Observable<any> {
    return undefined;
  }

  public deleteRecord(id: number): Observable<any> {
    return undefined;
  }

  public updateRecord(data: any): Observable<any> {
    return undefined;
  }

  public getSavedReportFile(reportId: number): Observable<SavedReportFileDTO> {
    const clientId = this.clientService.selectedClient ? this.clientService.selectedClient.id : 0;
    return this.savedReportClient.getSavedReportFile(clientId, reportId);
  }

  private correctCreatedByFilters(filters: FilterDTO[]) {
    if (!filters) {
      return;
    }
    const filtersToCorrect = FilterUtil.FindAllFiltersWithSpecificField('CreatedByName', filters);
    filtersToCorrect.forEach(f => {
      const filterOperator = f.operator;
      const values = f.value.split(' ');
      if (values.length > 1) {
        values.push(f.value);
      }
      f.condition = FilterCondition.Or;
      f.isComplex = true;
      f.operator = null;
      f.value = null;
      f.field = null;
      f.predicates = [];
      values.forEach(value => {
        f.predicates.push(new FilterDTO({ isComplex: false, field: 'CreatedByUser.Firstname', operator: filterOperator, value }));
        f.predicates.push(new FilterDTO({ isComplex: false, field: 'CreatedByUser.Lastname', operator: filterOperator, value }));
      });
    });
  }
}
